module.exports = __webpack_public_path__ + "static/media/undraw_Landing_page_re_6xev.7d9f9a8c.svg";